// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"ace83f6c","196":"1fe7d349","373":"f4670868","410":"da9b34bf","453":"9ca70c64","818":"44a6bcbe","966":"3279a092"}[chunkId] + ".chunk.js";
};